import ErrorPage from './error-page';

export default class ErrorPageDesktop extends ErrorPage {
}
